import axios from "axios";

const AUTH_STORAGE_KEYS = [
  "token",
  "role",
  "adminName",
  "adminSession",
  "engineerName",
  "engineerEmail",
  "engineerId",
  "engineerSession",
  "engineerCustomerViewEnabled",
  "accountsName",
  "accountsEmail",
  "accountsSession",
  "lgAdminName",
  "lgAdminSession",
];

const ROLE_SESSION_CONFIG = {
  admin: {
    nameKey: "adminName",
    sessionKey: "adminSession",
  },
  engineer: {
    nameKey: "engineerName",
    sessionKey: "engineerSession",
  },
  accounts: {
    nameKey: "accountsName",
    sessionKey: "accountsSession",
  },
  lg_admin: {
    nameKey: "lgAdminName",
    sessionKey: "lgAdminSession",
  },
};

const ROLE_LOGINS = {
  admin: "/admin-login",
  engineer: "/engineer-login",
  accounts: "/accounts-login",
  lg_admin: "/attendance/login/lg_admin",
};

export const clearAuthSession = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const isRoleSessionActive = (role) => {
  const config = ROLE_SESSION_CONFIG[role];
  if (!config) return false;

  const storedRole = localStorage.getItem("role");
  const hasName = Boolean(localStorage.getItem(config.nameKey));
  const hasToken = Boolean(localStorage.getItem("token"));

  return storedRole === role && hasName && hasToken;
};

export const logout = (navigate, redirectTo = "/") => {
  clearAuthSession();
  window.location.href = redirectTo;
};

/**
 * setupAxiosInterceptors
 *
 * Call once at app startup (in index.js).
 * - Attaches Authorization: Bearer <token> to every outgoing request.
 * - On 401 response: clears auth and redirects to login.
 */
export const setupAxiosInterceptors = () => {
  // Request interceptor — attach token
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor — handle 401 (expired/invalid token)
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        const role = localStorage.getItem("role");
        clearAuthSession();
        const loginPage = ROLE_LOGINS[role] || "/";
        window.location.href = loginPage;
      }
      return Promise.reject(error);
    }
  );
};

/**
 * appendAuthToken(url)
 *
 * Appends the JWT token as a query parameter to a URL.
 * Use for window.open() / anchor-based navigation that cannot set
 * Authorization headers (e.g. PDF preview in a new tab).
 */
export const appendAuthToken = (url) => {
  const token = localStorage.getItem("token");
  const cacheBuster = `_t=${Date.now()}`;
  if (!token) {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${cacheBuster}`;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}token=${encodeURIComponent(token)}&${cacheBuster}`;
};
